import { atom } from "jotai";
import { IAnalyticsShareLink } from "@/core/repositories/analytics";

export type ShareLinkStatus = "idle" | "loading" | "valid" | "expired" | "error";

export interface ShareLinkState {
  status: ShareLinkStatus;
  shareLink: IAnalyticsShareLink | null;
  error: Error | null;
  fetchedToken: string | null;
}

const initialState: ShareLinkState = {
  status: "idle",
  shareLink: null,
  error: null,
  fetchedToken: null,
};

export const shareLinkAtom = atom<ShareLinkState>(initialState);

export const shareLinkDataAtom = atom(get => get(shareLinkAtom).shareLink);
export const shareLinkStatusAtom = atom(get => get(shareLinkAtom).status);
